export class WebhookV1StandardPayloadBackupJobSucceeded {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupJobSucceededTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupJobSucceededArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobSucceeded.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupJobSucceededTypeEnum;
(function (WebhookV1StandardPayloadBackupJobSucceededTypeEnum) {
    WebhookV1StandardPayloadBackupJobSucceededTypeEnum["BackupJobSucceeded"] = "BACKUP_JOB_SUCCEEDED";
})(WebhookV1StandardPayloadBackupJobSucceededTypeEnum || (WebhookV1StandardPayloadBackupJobSucceededTypeEnum = {}));
